import React, { Component } from 'react'
import {connect} from "react-redux"
import { purchasePackage, clearPurchase, purchaseOnline, purchaseOnlineClear } from "../../actions/storeActions"
import ButtonLoader from "../btnloader"
import { RZPay, ajaxerrmsg } from '../../actions/http';
import { addToast } from '../../actions';
import { Redirect } from "react-router-dom"

class RechargeButton extends Component {

    handlePackageClick = () => {
        // this.click = true;
        // this.props.purchasePackage(this.props.id);
        this.props.addToast("Online payment not yet availbale");
    }

    render() {
        let {purchase, onlinePay} = this.props;
        if(onlinePay.data){
            return <Redirect to="/" />
        }
        return (
            <button 
                onClick={this.handlePackageClick} 
                type="button" className="btn btn-ouja btn-block"
                disabled={purchasePackage.fetching}
            >
                {purchase.fetching && this.click? <ButtonLoader /> : 'Purchase'}
            </button>
        )
    }

    componentDidUpdate(prevProps){
        let {user, purchase, onlinePay, purchaseOnline} = this.props;
        let {data} = purchase;
        if(data && !prevProps.purchase.data){
            RZPay(data, user, purchaseOnline);
        }
        this.checkError(purchase, prevProps.purchase);
        this.checkError(onlinePay, prevProps.onlinePay);
    }

    checkError(current, previous){
        if(current["error"] && !previous["error"]){
            this.props.addToast(ajaxerrmsg(current["error"]), false);
        }
    }

    componentWillUnmount(){
        this.props.clearPurchase();
        this.props.purchaseOnlineClear();
    }

}

const mapStateToProps = ({purchasePackage, loginReducer, purchaseOnline}) => ({
    purchase: purchasePackage,
    user: loginReducer.data,
    onlinePay: purchaseOnline
})

const mapDispatchToProps = {
    purchasePackage, clearPurchase, purchaseOnline, addToast, purchaseOnlineClear
}

export default connect(mapStateToProps, mapDispatchToProps)(RechargeButton)